@use "ui/styles/sizes";
@use "ui/styles/colors";
@use "ui/styles/fontStyles";

.wrapper {
  // Compensate for border
  // Match Studio, etc. nav bar
  padding: calc(sizes.$s4 + 1px) calc(sizes.$s4 + 1px) sizes.$s4 sizes.$s6;
  border-bottom: 1px solid colors.$gray20;
  background-color: colors.$brandWhite;
  @include fontStyles.subtitle2-book;

  :global {
    .top-nav-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: sizes.$s3;
      gap: sizes.$s4;
    }

    .top-nav-right {
      gap: sizes.$s4;
    }
  }

  .logo {
    margin-right: sizes.$s4;
  }
}

.mobileWrapper {
  position: relative;
  z-index: 1200;
}

.mobileHeader {
  position: relative;
  z-index: 1201;
  padding: sizes.$s3 sizes.$s4;
}

.mobileLeft {
  display: flex;
  align-items: center;
  gap: sizes.$s2;
}

.mobileRight {
  display: flex;
  align-items: center;
  gap: sizes.$s2;
  margin-left: auto;
}

.mobileMenuButton {
  min-width: auto;
  padding: sizes.$s2;
}

.mobileMenu {
  position: absolute;
  top: 100%;
  left: sizes.$s3;
  right: sizes.$s3;
  z-index: 1202;
  display: flex;
  flex-direction: column;
  gap: sizes.$s3;
  padding: sizes.$s3 sizes.$s4;
  border: 1px solid colors.$gray20;
  border-top: 0;
  border-radius: 0 0 sizes.$s3 sizes.$s3;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.14);
  border-bottom: 1px solid colors.$gray20;
  background-color: colors.$brandWhite;
}

.mobileMenuNav {
  display: flex;
  flex-direction: column;
  gap: sizes.$s2;
}

.mobileMenuActions {
  display: flex;
  align-items: center;
  gap: sizes.$s3;
}
